import React from "react"
import IconTrade from "@/assets/images/scheme/icon-trade.png";
import QueueAnim from "rc-queue-anim";
import Bg01 from "@/assets/images/product/construction/m-bg01.jpg";
import Bg02 from "@/assets/images/product/construction/m-bg02.jpg";
import Bg03 from "@/assets/images/product/construction/m-bg03.jpg";
import Bg04 from "@/assets/images/product/construction/m-bg04.jpg";
import OverPack from "rc-scroll-anim/lib/ScrollOverPack";

const ManagerList = () => {
  return (
    <div className='warp-visit wrap-bank-list' style={{minHeight: '4500px', backgroundColor: '#FFFFFF'}}>
      <div className='wrap-bank-list-header'>
        <div className='wrap-bank-list-header-box home-page'>
          <img src={IconTrade} alt=""/>
          <div className='wrap-title'>构建面向不确定性的全生命周期人才管理体系</div>
        </div>
      </div>
      <div className='wrap-bank-list-summary'>
        <div className='home-page'>
          <div className='warp-visit-content-items'>
            <div className='content-item' style={{padding: '0px'}}>
              <div className='content-item-block' style={{marginTop: '0px'}}>
                <div className='b-content p-pre-wrap'>
                  企业正处于多重变量叠加的战略震荡期。政策逻辑、技术曲线、产业周期与竞争格局同步剧变，“战略定下来、组织跟不上去”正在成为常态。人工智能也在加速改写每一个岗位的定义——人才管理已不再是“培养多少人的问题”，而是能否在变化发生之前，把对的人放到对的位置上。我们回归人才管理的本质，以成熟咨询方法论为依托，从规划、标准、盘点、培养四个节点入手，提供全生命周期的人才管理闭环服务。帮助企业在动荡中校准人才标尺、在筛选中识别良将、在实战中锻造梯队，打造素质过硬、本领高强的复合型人才队伍，让组织能力始终跑在战略前面。
                </div>
              </div>
            </div>
          </div>
          <div className='warp-visit-content-items'>
            <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
              <div className='content-item-block'>
                <div className='b-title'>
                  组织诊断：人才管理的五大典型失衡
                </div>
                <div className='wrap-b-desc'>
                  <div className='b-desc'>
                    <div className='dot'></div>
                    <div className='text'>
                      <span>战略已转，人才滞后：</span>人才布局滞后于战略步伐，转型或扩张期常面临“无兵可用”的业务窘境。
                    </div>
                  </div>
                  <div className='b-desc'>
                    <div className='dot'></div>
                    <div className='text'>
                      <span>标尺模糊，人岗错配：</span>选拔过度依赖经验主义，缺乏兼顾市场化导向与合规要求的科学标尺，导致业人错位。
                    </div>
                  </div>
                  <div className='b-desc'>
                    <div className='dot'></div>
                    <div className='text'>
                      <span>家底不清，高潜埋没：</span>缺乏常态化盘点机制，人才数据未沉淀，核心高潜人才在组织内部处于隐形状态。
                    </div>
                  </div>
                  <div className='b-desc'>
                    <div className='dot'></div>
                    <div className='text'>
                      <span>梯队悬空，青黄不接：</span>关键岗位“青黄不接”，新老交替期面临能力断层，业务连续性缺乏保障。
                    </div>
                  </div>
                  <div className='b-desc'>
                    <div className='dot'></div>
                    <div className='text'>
                      <span>赋能空转，不见实效：</span>赋能体系脱离业务实战，“漫灌式”培训缺乏靶向性，难以转化为真实的组织绩效。
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
              <div className='content-item-block'>
                <div className='b-title'>
                  全链路人才管理解决方案
                </div>
                <div className='b-content p-pre-wrap'>
                  <div className='b-content p-pre-wrap'>
                    围绕党组织四类核心人群分层培养，定制差异化人才成长项目，打通从入党积极分子到党组织书记全成长链路，系统化补齐党务履职、党建融业务能力短板，搭建企业自有党务骨干人才梯队。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '40px'}}
            >
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title'>
                1. 战略导向的人才规划：精准刻画人才供应链地图
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                打破传统人力资源规划的静态模式，对标世界一流企业价值创造行动与企业中长期战略，将人才规划升级为敏捷的“人才供应链”管理。我们以“五步法”逐层递进，将战略意图精准解码为人才行动方案，确保组织在任何战略姿态下都“有将可用、有兵可调”。
              </div>
              <img src={Bg01} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '60px'}}
            >
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title'>
                2. 精准适配的人才标准：构建立体化胜任力模型库
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                标准是人才管理的“度量衡”——标准对了，选人、用人、育人才能方向一致。我们以“双视角输入—轻量化建模—立体化输出”为核心方法论，融合战略诉求与业务实况，为企业量身定制兼顾战略适配性与组织特性的能力标尺。
              </div>
              <img src={Bg02} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '60px'}}
            >
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title'>
                3. 效能驱动的人才盘点：多维立体评估与梯队落位
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                将盘点视作组织的深度“健康体检”。综合运用专业评价技术，全方位摸清组织人才家底。输出高潜人才九宫格、个体及团队诊断报告与继任者地图，为关键岗位建立安全、动态的人才储备池。盘点的终点不是一张九宫格，而是三个用人决策：资源向谁投、岗位谁来接、阵型怎么调。
              </div>
              <img src={Bg03} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '60px'}}
            >
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title'>
                4.定制化项目设计新逻辑：始于业务诊断，终于价值验证
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                AI驱动的人才测评与业务数据穿透，精准识别能力短板与组织痛点。 <br />
                紧贴业务场景的靶向输入，人机协同的认知升级与能力装配，让学习与实战有密联。<br />
                将学习成果直接投入真实业务场景验证，在实际攻坚中完成从知识到能力的转化。<br />
                以数据追踪行为转化与绩效改善，用业务结果验证培养价值，驱动持续进化。
              </div>
              <img src={Bg04} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
        </div>
      </div>
    </div>
  )
}

export default ManagerList